import { readEnvVariable } from '.';
import { getFeatureFlagValue } from './network';
import logger from './logger';
import { setMenuUnificationFeatureFlag } from './session-storage';

let prefetchPromise: Promise<boolean> | null = null;
let prefetchedForRestaurant: string | null = null;

/**
 * Pre-fetches the unified_menu feature flag for a restaurant code.
 * Called when a task assignment WS message arrives so the flag is
 * already resolved by the time RestaurantsContainer mounts.
 */
export const prefetchMenuUnificationFlag = (
  restaurantCode: string
): Promise<boolean> => {
  prefetchedForRestaurant = restaurantCode;
  prefetchPromise = getFeatureFlagValue({
    url: `${readEnvVariable('UNLEASH_API_URL')}?userId=${restaurantCode}`,
    name: 'unified_menu',
  })
    .then((flag) => {
      setMenuUnificationFeatureFlag(flag.toString());
      logger.info({
        message: `Prefetched unified_menu feature flag for ${restaurantCode}: ${flag}`,
      });
      return flag;
    })
    .catch((error) => {
      logger.error({
        message: `Failed to prefetch unified_menu feature flag for ${restaurantCode}`,
        error,
      });
      prefetchPromise = null;
      prefetchedForRestaurant = null;
      return false;
    });
  return prefetchPromise;
};

/**
 * Consumes the prefetched flag promise if it matches the given restaurant.
 * Returns the promise if available, or null if no prefetch was done.
 */
export const consumePrefetchedFlag = (
  restaurantCode: string
): Promise<boolean> | null => {
  if (prefetchPromise && prefetchedForRestaurant === restaurantCode) {
    const promise = prefetchPromise;
    prefetchPromise = null;
    prefetchedForRestaurant = null;
    return promise;
  }
  return null;
};
